import React from 'react';

const Button = ({ children, onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`
        bg-black text-white px-8 py-3 rounded-full text-lg font-semibold
        hover:bg-gray-800 transition-colors duration-200 ease-in-out
        focus:outline-none focus:ring-2 focus:ring-black focus:ring-opacity-50
        ${className}
      `}
    >
      {children}
    </button>
  );
};

export default Button;